import ChargerModule from 'components/chargerModule';
import DonwloadUploadQuotesModule from './DonwloadUploadQuotesModule';

export const DonwloadUploadQuotes = () => {
  return (
    <ChargerModule
      headerInfo={{
        title: 'Cargue masivo de cotizaciones',
        subtitle: '',
        titleRoute: '/bulk-upload/type-of-charge'
      }}
      infoSideBar={{ position: 'bulkUpload' }}
    >
      <DonwloadUploadQuotesModule />
    </ChargerModule>
  );
};
